import { Navigate, lazyRouteComponent } from "@tanstack/react-router";
import { ShieldCheck } from "lucide-react";

import type { PageDef } from "@/app/registry";

import { ADMIN_ROOT, ADMIN_SECTIONS, MOVED_PATHS } from "./sections";

// One route per admin page (sections.tsx), all rendered by AdminLayout. Only the
// section's root is in the app sidebar; the admin sub-nav lists the rest.
// ownerOnly: the registry shows them to admins only ("admin" or "owner"), so
// employees still see just the sales console; the server enforces admin on
// every /admin route regardless.
const layout = lazyRouteComponent(() => import("./AdminLayout"), "AdminLayout");

export const pages: PageDef[] = ADMIN_SECTIONS.map((s) => ({
  path: s.path,
  title: s.path === ADMIN_ROOT ? "Admin" : `Admin · ${s.label}`,
  component: layout,
  ownerOnly: true,
  ...(s.path === ADMIN_ROOT
    ? { nav: { label: "Admin", icon: ShieldCheck, group: "System" as const, order: 5 } }
    : {}),
  ...(s.validateSearch ? { validateSearch: s.validateSearch } : {}),
})).concat(
  // merged pages: the old URL goes to the page that took it over
  Object.entries(MOVED_PATHS).map(([from, to]) => ({
    path: from,
    title: "Admin",
    component: () => <Navigate to={to as never} replace />,
    ownerOnly: true,
  })),
);
